import { Extension } from '@tiptap/core';
import type { NodeType } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';

/**
 * Ported from client/src/components/TiptapEditor/extensions/TrailingNode, itself based on:
 * - https://github.com/ueberdosis/tiptap/blob/v1/packages/tiptap-extensions/src/extensions/TrailingNode.js
 * - https://github.com/remirror/remirror/blob/e0f1bec4a1e8073ce8f5500d62193e52321155b9/packages/prosemirror-trailing-node/src/trailing-node-plugin.ts
 */

export interface TrailingNodeOptions {
  node: string;
  notAfter: string[];
}

export const TrailingNode = Extension.create<TrailingNodeOptions>({
  name: 'trailingNode',

  addOptions() {
    return {
      node: 'paragraph',
      notAfter: ['paragraph'],
    };
  },

  addProseMirrorPlugins() {
    const pluginKey = new PluginKey(this.name);

    const disabledNodes: NodeType[] = Object.values(this.editor.schema.nodes).filter((node) =>
      this.options.notAfter.includes(node.name),
    );

    return [
      new Plugin({
        key: pluginKey,

        appendTransaction: (_, __, state) => {
          const { doc, tr, schema } = state;
          const shouldInsertNodeAtEnd = pluginKey.getState(state);
          const type = schema.nodes[this.options.node];
          const endPosition = doc.content.size;

          if (!shouldInsertNodeAtEnd) {
            return;
          }

          return tr.insert(endPosition, type.create());
        },

        state: {
          init: (_, { tr: { doc } }) => {
            const lastNode = doc.lastChild;
            if (!lastNode) return true;

            return !disabledNodes.includes(lastNode.type);
          },
          apply: ({ doc, docChanged }, value) => {
            if (!docChanged) {
              return value;
            }

            const lastNode = doc.lastChild;
            if (!lastNode) return true;

            return !disabledNodes.includes(lastNode.type);
          },
        },
      }),
    ];
  },
});
